/*
 * @Author: yangsibo
 * @Date: 2022-03-24 10:23:31
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-19 10:18:04
 * @Description: 公用方法
 * @FilePath: /adm.xiangli360.com/src/utils/common.js
 */
/**
 * @description: 校验手机号
 * @Author: yangsibo
 * @Date: 2022-03-31 15:59:59
 * @param {*} rule 校验规则
 * @param {*} value 输入框value
 * @param {*} callback 校验回调
 * @param {*} flag change校验
 * @param {*} fn change回调
 * @return {*}
 */

import router from "@/router";
const checkMobile = (rule, value, callback, flag, fn) => {
  if (!value) {
    return flag == "change" ? fn() : callback(new Error("请输入手机号码"));
  } else {
    var reg =
      /^1(([3,6,7,8][0-9]{9})|(4[5,7][0-9]{8})|(5[0,1,2,3,5,6,7,8,9][0-9]{8})|(7(([0,5][0-9]{8})|([1,3,6,7,8][0-9]{8})))|(9[1,8,9][0-9]{8}))$/;
    if (!reg.test(value)) {
      flag == "change" ? fn() : callback(new Error("请输入正确格式的手机号码"));
    } else {
      flag == "change" ? fn(true) : callback();
    }
  }
};
/**
 * @Description: 校验登录账号
 * @Author: yangsibo
 * @Date: 2022-10-12 15:49:45
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 * @return {*}
 */
const checkLoginName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请填写登录账号"));
  } else {
    let reg = /^(?=.*[a-zA-Z])(?=.*\d).+$/;
    if (!reg.test(value)) {
      callback(new Error("账号建议设置为字母和数字组合，不支持设置为纯数字"));
    } else {
      callback();
    }
  }
};
const checkIdCard = (rule, value, callback) => {
  if (value) {
    let regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (!regIdNo.test(value)) {
      callback(new Error("请输入正确格式的身份证号码"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};
const checkIdAccount = (rule, value, callback) => {
  if (value) {
    const reg = /^(?![0-9]+$)[0-9A-Za-z]{6,20}$/;
    if (!reg.test(value)) {
      callback(new Error("请输入正确格式的登录账号"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};
const checkSubDomain = (rule, value, callback) => {
  if (value) {
    const reg = /^(?![0-9]+$)[0-9A-Za-z]{2,20}$/;
    if (!reg.test(value)) {
      callback(new Error("请输入正确格式的二级域名"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};
const checkIdPassword = (rule, value, callback) => {
  if (value) {
    const reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*(){}\[\]?_]).{12,20}$/;
    if (!reg.test(value)) {
      callback(new Error("请输入正确格式的密码"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};
/**
 * @Author: yangsibo
 * @description: 防抖
 * @Date: 2022-03-23 14:09:26
 * @param {*} fun 调用的函数
 * @param {*} delay 防抖时间
 * @return {*}
 */
let timer = null;
const debounce = (fun, delay = 100, immediate, that) => {
  return function (...arg) {
    if (timer) {
      clearInterval(timer);
    }
    //immediate 立即触发
    if (immediate && !timer) {
      fun.apply(that, [...arg]);
    }
    timer = setTimeout(() => {
      fun.apply(that, [...arg]);
    }, delay);
  };
};
/**
 * @description:
 * @Author: yangsibo
 * @Date: 2022-03-31 15:59:22
 * @param {*} rule 校验规则
 * @param {*} value 输入框value
 * @param {*} callback 校验回调
 * @return {*}
 */
const checkStarLevel = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请选择机手星级"));
  } else {
    callback();
  }
};
/**
 * @description: 限制为保留两位小数点的数字格式
 * @Author: yangsibo
 * @Date: 2022-04-01 14:40:28
 * @param {String} value 需要限制的值
 * @return {String} 返回字符串格式的数字
 */
const numberLimit = (value) => {
  return (
    ("" + value) // 第一步：转成字符串
      .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
      .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
      .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
      .match(/^\d*(\.?\d{0,2})/g)[0] || ""
  ); // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
};

/**
 * @description 设置缓存的数据
 * @Author qixiao
 * @Date 2024-01-04 14:28:53
 * @param data
 */
export const setSessionStorageQuery = (data) => {
  const sessionData = {
    path: router.currentRoute.path, // 使用路由路径当成唯一标识
    cacheData: data,
  };
  sessionStorage.setItem("rowInfo", JSON.stringify(sessionData));
};
/**
 * @description 清除缓存的数据
 * @Author qixiao
 * @Date 2024-01-04 15:01:05
 */
export const removeSessionStorageQuery = (data) => {
  sessionStorage.removeItem("rowInfo");
};
/**
 * @description 获取缓存的数据
 * @Author qixiao
 * @Date 2024-01-04 14:29:27
 * @param data
 */
export const getSessionStorageQuery = (data) => {
  const rowInfo = sessionStorage.getItem("rowInfo");
  if (!rowInfo) {
    return "";
  }
  try {
    const sessionData = JSON.parse(rowInfo);
    // 路由匹配上才返回缓存的数据
    if (sessionData.path === router.currentRoute.path) {
      return sessionData.cacheData;
    }
    return "";
  } catch (e) {
    return "";
  }
};

export default {
  checkMobile,
  debounce,
  checkStarLevel,
  numberLimit,
  checkIdCard,
  checkLoginName,
  checkIdAccount,
  checkIdPassword,
  checkSubDomain,
};
